// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dcc94bb6","453":"5833dec9","732":"59b407fe","977":"453a3fb0"}[chunkId] + ".chunk.js";
};